import React, {useEffect, useState} from 'react';
import {AppBar, Box, Grid, Tab, Tabs, Toolbar} from "@material-ui/core";
import {Route, Switch, useHistory} from 'react-router-dom';
import SubHeader from "components/helpers/subHeader/subHeader";
import {Digital} from "./Digital";
import {Manual} from "./Manual";
import {useLocation, useRouteMatch} from "react-router";

const basePath = '/aprobaciones/rendiciones/cobranza';

export const Cobranzas = () => {
    const [tabActive, setTabActive] = useState('digital');

    const history = useHistory();
    const location = useLocation();
    const match = useRouteMatch();

    useEffect(() => {
        if (location.pathname.indexOf('manual') > -1)
            setTabActive('manual');
    }, []);

    const changeTab = (event, value) => {
        setTabActive(value);
        history.push(`${match.url}/${value}`);
    };

    return (
        <div>
            <SubHeader
                title={'Rendiciones'}
                subtitle={'Confirmar rendiciones de cobranza'}
            />
            <AppBar position="relative" elevation={0}>
                <Toolbar variant="dense" color='primary'>
                    <Grid container justifyContent="space-between" alignItems="center">
                        <Grid item>
                            <Tabs
                                value={tabActive}
                                onChange={changeTab}
                                indicatorColor="secondary"
                                textColor="inherit"
                            >
                                <Tab label="Manual" value='manual'/>
                                <Tab label="Digital" value='digital'/>
                            </Tabs>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
            <Box className='container-xl mt-3 mb-3'>
                <Switch>
                    <Route path={`${basePath}/manual`} render={() => <Manual key={"manual"}/>}/>,
                    <Route path={`${basePath}`} render={() => <Digital key={"digital"}/>}/>
                </Switch>
            </Box>
        </div>
    )
}